import React from 'react';
import { Box, Typography, Card, CardContent } from '@mui/material';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Autoplay } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/pagination';

const milestones = [
  {
    date: 'July 2024',
    title: 'Incorporated',
    description:
      'Anthrasync Solutions Private Limited was officially registered and incorporated.',
  },
  {
    date: 'August 2024',
    title: 'Startup India Recognition',
    description:
      'Received recognition under the Startup India program, validating our innovation and growth potential.',
  },
  {
    date: 'Nov 2024',
    title: 'Official Website Launch',
    description:
      'Our official company website went live, offering users a central place to learn about our services.',
  },
  {
    date: 'January 2025',
    title: 'First Platform Launch',
    description:
      'Released the first version of our core platform with essential features for early adopters.',
  },
  {
    date: 'April 2025',
    title: 'Major Update',
    description:
      'Rolled out a significant update with improved UI/UX, performance enhancements, and new capabilities.',
  },
  {
    date: 'September 2025',
    title: 'Startup Karnataka Recognition',
    description:
      'Received recognition by Startup Karnataka, validating our innovation and growth potential.',
  },
  {
    date: 'October 2025',
    title: 'Top AI Startup Award',
    description:
      'Recognized as “10 Best AI Startups from Bangalore – 2025” by SiliconIndia.',
  },
];

const JourneyPage = () => {
  return (
    <Box
      id="journey"
      sx={{
        py: { xs: 6, md: 10 },
        px: { xs: 3, md: 6 },
        backgroundColor: '#000000',
        color: '#ffffff',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        mb: 10,
      }}
    >
      {/* Heading */}
      <Typography
        component="h2"
        variant="h3"
        align="center"
        sx={{
          letterSpacing: 8,
          fontWeight: 'bold',
          textTransform: 'uppercase',
          position: 'relative',
          mb: 6,
          '&::after': {
            content: '""',
            position: 'absolute',
            width: '60%',
            height: '4px',
            bottom: -8,
            left: '20%',
            background: 'linear-gradient(90deg, #1E90FF, #00C9FF)',
            borderRadius: 2,
          },
          '&:hover': {
            color: '#1E90FF',
          },
        }}
      >
        Our Journey So Far
      </Typography>

      {/* Swiper */}
      <Box sx={{ width: '100%', maxWidth: '1100px' }}>
        <Swiper
          modules={[Pagination, Autoplay]}
          spaceBetween={30}
          pagination={{
            clickable: true,
          }}
          autoplay={{
            delay: 3500,
            disableOnInteraction: false,
          }}
          breakpoints={{
            0: { slidesPerView: 1 },
            600: { slidesPerView: 2 },
            960: { slidesPerView: 3 },
          }}
          style={{
            paddingBottom: '60px',
            '--swiper-pagination-color': '#1E90FF',
            '--swiper-pagination-bullet-inactive-color': '#ffffff',
            '--swiper-pagination-bullet-size': '10px',
            '--swiper-pagination-bullet-horizontal-gap': '8px',
          }}
        >
          {milestones.map((milestone, index) => (
            <SwiperSlide key={index}>
              <Card
                elevation={8}
                sx={{
                  height: '100%',
                  background: 'linear-gradient(145deg, #000000, #050505)',
                  borderRadius: 3,
                  border: '1px solid #1E90FF30',
                  transition: 'all 0.3s ease',
                  '&:hover': {
                    transform: 'translateY(-8px)',
                    boxShadow: '0 12px 30px rgba(30, 144, 255, 0.35)',
                    borderColor: '#1E90FF',
                  },
                }}
              >
                <CardContent sx={{ p: 4 }}>
                  <Typography
                    variant="overline"
                    sx={{
                      color: '#1E90FF',
                      letterSpacing: 2,
                      fontSize: '0.85rem',
                    }}
                  >
                    {milestone.date}
                  </Typography>

                  <Typography
                    variant="h6"
                    sx={{
                      mt: 1,
                      mb: 2,
                      letterSpacing: 2,
                      fontWeight: 600,
                      color: 'white',
                    }}
                  >
                    {milestone.title}
                  </Typography>

                  <Typography
                    variant="body2"
                    sx={{
                      color: '#cfcfcf',
                      letterSpacing: 1,
                      lineHeight: 1.7,
                    }}
                  >
                    {milestone.description}
                  </Typography>
                </CardContent>
              </Card>
            </SwiperSlide>
          ))}
        </Swiper>
      </Box>
    </Box>
  );
};

export default JourneyPage;
